export const portfolio_data = [

    {
        "id": 16,
        "image": require("../../assets/draff.jpeg"),
        "title": "Draff",
        "stack": "Next Js, Clerk , PostgreSQL",
        "desc": "Collaborate , manage projects and reach new productivity peaks from high rise to the home office , the way your team works is unique - accomplsh it all with Draff",
        "demo_url": "https://trello-git-sheriff-sheriff-gayes-projects.vercel.app/",
         "category": "fullstack"
    },

    {
        "id": 6,
        "image": require("../../assets/natures2.jpeg"),
        "title": "Natures Yoghurt",
        "stack": "Laravel , Livewire , SQL",
        "desc": "Natures Yoghurt is a yoghurt company with an eloquent UI and e-commerce functionality built with Laravel and Javascript.",
        "demo_url": "https://naturesyoghurt.com",
         "category": "ecommerce"

    }
    ,
    {
        "id": 12,
        "image": require("../../assets/airbnb.jpeg"),
        "title": "Home Harmony",
        "stack": "Next JS , MongoDB , Prisma ",
        "desc": "Home Harmony your Airbnb alternative (clone) for listing homes, apartments, islands, and villas. Book with ease for a convenient and personalized experience in comfortable accommodations.",
        "demo_url": "https://homeharmoney.vercel.app/",
        "category": "fullstack"

    },

    {
        "id": 13,
        "image": require("../../assets/shop.jpeg"),
        "title": "Shop Sphere",
        "stack": "Next JS , Prisma , Shadcn, Tailwind",
        "desc": " Multistore ecommerce platform with an intuitive admin panel for easy store customization. Seamless card payment options enhance customer convenience. Ideal for showcasing diverse storefronts.",
        "demo_url": "https://shopsphere-six.vercel.app",
        "category": "ecommerce"

        



    },
    {
        "id": 1,
        "image": require("../../assets/lms.png"),
        "title": "EasyLearn",
        "desc": "EasyLearn is an educational platform blends cutting-edge technology with a user-friendly interface, offering an immersive learning experience..",
        "stack": "Next Js, Clerk , Tailwind , Prisma",
        "demo_url": "https://lms-easylearn.vercel.app",
        "category": "education"

        //   "git_url": "https://github.com/sheriff-gaye/learning_management_system.git"

    },
    {
        "id": 1,
        "image": require("../../assets/school.jpeg"),
        "title": "Web Mastery",
        "stack": "HTML,CSS JavaScript",
        "desc": "Web Mastery  A premier entity in digital landscapes, specializing in crafting innovative websites and mastering online presence. ",
        "demo_url": "https://sheriff-gaye.github.io/javascript_projects/school/index.html",
         "category": "frontend"
    },
    {
        "id": 3,
        "image": require("../../assets/gym.jpeg"),
        "title": "Get Fit",
        "stack": "React , Swiper Js",
        "desc": "Get Fit is a minimalist fitness center website with a gorgeous user interface, developed with standard React JS.",
        "demo_url": "https://sheriff-gaye.github.io/getfit",
        "category": "frontend"
        // "git_url": "https://github.com/sheriff-gaye/getfit"
    },



    {
        "id": 9,
        "image": require("../../assets/client.png"),
        "title": "MyClientHub",
        "stack": "Laravel , Livewire , SQL , Tailwind",
        "desc": "MyClientHub is a comprehensive CRM solution that helps businesses efficiently manage clients, projects, and tasks, streamlining communication and boosting productivity.",
        // "demo_url": "",
        "git_url": "https://github.com/sheriff-gaye/laravel_crm",
        "category": "fullstack"
    },
    {
        "id": 11,
        "image": require("../../assets/Screenshot 2023-06-11 at 11.40.32 PM.png"),
        "title": "Car Hub",
        "stack": "Next JS ",
        "desc": "MyClientHub is a comprehensive CRM solution that helps businesses efficiently manage clients, projects, and tasks, streamlining communication and boosting productivity.",
        "demo_url": "https://carapp-silk.vercel.app/",
        "category": "frontend"
    },




    {
        "id": 14,
        "image": require("../../assets/great_minds.jpeg"),
        "title": "Great Minds Health Care",
        "stack": "HTML , CSS , JS , Swiper JS",
        "desc": " Great Mind Hospital Care is a user-friendly website designed for students, staff, and stakeholders. It features a sleek UI design, allowing students to easily contact the hospital and schedule appointments.",
        "demo_url": "https://sheriff-gaye.github.io/hospital_website/",
        "category": "frontend"

    },
    {
        "id": 14,
        "image": require("../../assets/nike.jpeg"),
        "title": "KicksHub",
        "stack": "React JS",
        "desc": "Kicks Hub A sleek React.js Nike website clone for online shoe sales, featuring a modern UI and extensive functionality for seamless shopping and user experience.",
        "demo_url": "https://kickshub.vercel.app/",
        "category": "frontend"

    },
    
    {
        "id": 15,
        "image": require("../../assets/github.jpeg"),
        "title": "Github API",
        "stack": "HTML , CSS , JavaScript",
        "desc": "A highly organized, user-friendly note-taking web app built with React. Users can create, edit, and delete notes, all while utilizing the browser's local storage as its database for seamless data management",
        "demo_url": "https://sheriff-gaye.github.io/javascript_projects/Github-profile/index.html",
        "category": "frontend"
    },






]


export default portfolio_data

